export const BASE_URL = process.env.REACT_APP_BASE_URL;//"https://upschat.demoquaeretech.in/"//?
export const BASE_URL_IMG = process.env.REACT_APP_BASE_URL_IMG;//"https://upschat.demoquaeretech.in/"; //?
// export const BASE_URL = "http://192.168.23.20:8000/"; //?
// export const BASE_URL_IMG = "http://192.168.23.20:8000/"; //?
export const BASE_URL_BOT =  process.env.REACT_APP_BOT_URL;//"https://upschat.demoquaeretech.in/api/";
export const SECRET_KEY = process.env.REACT_APP_SECRET_KEY;

export const roleList = [
  { value: "super_admin", label: "Super Admin" },
  { value: "admin", label: "Admin" },
];

/** Admin user permissions (maps to permission_key in DB). */
export const adminPermissionOptions = [
  { key: "qa.view", label: "View", group: "Questions (QA)" },
  { key: "qa.approve", label: "Approve", group: "Questions (QA)" },
  { key: "qa.reject", label: "Reject", group: "Questions (QA)" },
  { key: "qa.edit", label: "Edit", group: "Questions (QA)" },
  { key: "qa.create", label: "Create", group: "Questions (QA)" },
  { key: "users.view", label: "View users", group: "Users" },
];
